import { useEffect, useState } from 'react';
import { getDefaultTimeZoneOnBrowser } from '../util/dates';

// Local storage key for the user's timezone preference
const USER_TIMEZONE_KEY = 'SoulWiseUserSelectedTimezone';

/**
 * Custom hook for managing timezone selection with localStorage persistence
 *
 * @param {string|null} initialTimezone - Optional initial timezone value
 * @returns {[string|null, function]} - Current timezone and function to change it
 */
export const useTimezone = (initialTimezone = null) => {
  const [timezone, setTimezone] = useState(initialTimezone);

  // Initialize timezone on first render if not provided
  useEffect(() => {
    if (!timezone) {
      const storedTimezone = localStorage.getItem(USER_TIMEZONE_KEY);
      const detectedTimezone = getDefaultTimeZoneOnBrowser();
      const newTimezone = storedTimezone || detectedTimezone || 'Etc/UTC';
      setTimezone(newTimezone);
    }
  }, [timezone]);

  // Handle timezone change with storage
  const changeTimezone = newTimezone => {
    localStorage.setItem(USER_TIMEZONE_KEY, newTimezone);
    setTimezone(newTimezone);
  };

  return [timezone, changeTimezone];
};

export default useTimezone;
